// peticiones a backend
import axios from 'axios';

const base_url = process.env.REACT_APP_NEFRO_API_URL; // servidor en Node.js
// API de Nefrópolis (dirección; cp, colonia, ciudad, estado)
const nefro_url = process.env.REACT_APP_API_NEFROPOLIS_URL;

// peticiones de aplicación
const request = (endpoint, obj, method = 'GET') => {
    const url = `${base_url}/${endpoint}`;
    if (method === 'GET')
        return fetch(url, { method });
    else {
        return fetch(url, {
            method,
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(obj)
        });
    }
};

// petición restringida (sólo administradores)
const protectedReq = (endpoint, obj, method = 'GET') => {
    const url = `${base_url}/${endpoint}`;
    // token guardado
    const token = localStorage.getItem('token') || '';
    if (method === 'GET')
        return fetch(url, {
            method,
            headers: {
                'x-token': token
            }
        });
    else
        return fetch(url, {
            method,
            headers: {
                'Content-type': 'application/json',
                'x-token': token
            },
            body: JSON.stringify(obj)
        });
};

// petición a api.nefropolis
const nefroRequest = async(endpoint, form, method = 'GET') => {
    const url = `${nefro_url}/${endpoint}`;
    if (method === 'GET')
        return await axios.get(url);
    else
        return await axios.post(url, form);
};

export {
    request, protectedReq,
    nefroRequest
};